import { Box, Table, TableBody, TableCell, TableRow, makeStyles, Theme } from '@material-ui/core';
import { formatCurrency } from '@roc/ui/utils';
import { FieldReviewRow, FieldReviewTable } from '../fieldReviewTable';
import { withoutPortalOnlyRows } from './identityReviewValues';
import { DocReviewSection } from '../../docReviewSection';

const useStyles = makeStyles((theme: Theme) => ({
  headCell: {
    color: theme.palette.text.secondary,
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  headMatchCell: {
    backgroundColor: '#FAFAFA',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    width: '5%',
  },
  matchCell: {
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    width: '5%',
  },
  labelCell: {
    width: '40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
}));

const formatAmount = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') return '—';
  const amount = Number(value);
  return Number.isFinite(amount) ? formatCurrency(amount) : String(value);
};

const FinancialDataTable = ({ items }: { items: FieldReviewRow[] }) => {
  const classes = useStyles();
  if (items.length === 0) {
    return null;
  }
  return (
    <DocReviewSection title="Financial Data" hideEdit>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.headMatchCell} />
            <TableCell className={classes.headCell}>Field</TableCell>
            <TableCell className={classes.headCell}>Portal</TableCell>
          </TableRow>
          {items.map((item, index) => (
            <TableRow key={item.itemName} className={index === items.length - 1 ? classes.lastRow : ''}>
              <TableCell className={classes.matchCell} />
              <TableCell className={classes.labelCell}>{item.itemDisplayName}</TableCell>
              <TableCell className={classes.valueCell}>{formatAmount(item.expectedData ?? item.data)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </DocReviewSection>
  );
};

const extractedRows = (data: Record<string, any>): FieldReviewRow[] =>
  (data?.extractedData ?? []).filter((row: FieldReviewRow) => !!row?.itemName);

export const IdentityReviewTable = ({ data }: { data: Record<string, any> }) => (
  <FieldReviewTable items={withoutPortalOnlyRows(extractedRows(data))} />
);

export const IdentityFinancialDataSection = ({ data }: { data: Record<string, any> }) => {
  const rows = extractedRows(data);
  const documentRows = withoutPortalOnlyRows(rows);
  const financialRows = rows.filter(row => !documentRows.includes(row));
  if (financialRows.length === 0) {
    return null;
  }
  return (
    <Box mt={2} mb={2}>
      <FinancialDataTable items={financialRows} />
    </Box>
  );
};
